import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import Modal from "features/components/modal";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {TextField} from "features/components/text-field";
import PasswordTextField from "features/components/password-text-field";
import {historyObject} from "historyObject";
import {EmailValidator, PasswordValidator} from "services/utils/validations";
import Checkbox from "features/components/checkbox";
import {connect} from "react-redux";
import {loginStart} from "features/pages/account/login/reducer";
import {loginError, loginLoading} from "features/pages/account/login/selectors";
import {needToChangeTempPassword} from "store/reducer/auth/selectors";
import TempPassword from "features/pages/account/temp-password";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: loginLoading(state),
    error: loginError(state),
    needToChangeTempPassword: needToChangeTempPassword(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    loginStart
};

export const LoginPage = (props) => {
    const {loginStart, loading, error, needToChangeTempPassword} = props;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [remember, setRemember] = useState(false);

    const handleForgot = useCallback(() => {
        historyObject.push("/forgot");
    }, []);
    const handleLogin = useCallback(() => {
        loginStart({email, password, remember});
    }, [email, password, remember, loginStart]);

    const validateEmail = useCallback((val) => {
        return EmailValidator(val) ? null : __("validator.invalid-email");
    }, []);
    const validatePassword = useCallback((val) => {
        return PasswordValidator(val) ? null : __("validator.invalid-password");
    }, []);

    const loginEnabled = useMemo(() => {
        return EmailValidator(email) && PasswordValidator(password);
    }, [email, password]);

    return <LoggedOutLayout type={"dark"} className={"login-page"}>
        <Modal>
            <Title size={34} align={"center"}>{__("login.title")}</Title>
            <Text size={16} align={"center"}>{__("login.text")}</Text>
            <div className={"field-box"}>
                <TextField
                    type={"text"}
                    value={email}
                    onChange={setEmail}
                    placeholder={__("text-fields.email.placeholder")}
                    hint={__("text-fields.email.hint")}
                    validationFunc={validateEmail}
                />
                <PasswordTextField
                    value={password}
                    onChange={setPassword}
                    placeholder={__("text-fields.password.placeholder")}
                    hint={__("text-fields.password.hint")}
                    validationFunc={validatePassword}
                />
                <Checkbox value={remember} onChange={setRemember} label={__("login.remember.label")} />
            </div>
            {error.inError && <Text color={"danger"} size={16}>{__(error.error)}</Text>}
            <Button title={__("buttons.forgot-password")} onClick={handleForgot} type={"clear"} />
            <Button title={__("buttons.login")} disabled={!loginEnabled} onClick={handleLogin} status={loading ? "loading" : null} icon={"arrow-right"} />
        </Modal>
        {needToChangeTempPassword && <TempPassword />}
    </LoggedOutLayout>
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);